export abstract class ContentItem {
  protected _type: string = '';

  get type() {
    return this._type;
  }

  abstract copy();
  abstract toJson();
}


// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/models/content-items/content-item.model.ts